import { MouseEvent } from 'react'

import { EMPTY_VALUE } from '@/constants/ui'
import { openMailWithGmailFallback } from '@/utils/mailto'

import * as S from './email-link.styled'

export interface EmailLinkProps {
  email?: string | null
}

export const EmailLink = ({ email }: EmailLinkProps) => {
  if (!email) return <>{EMPTY_VALUE}</>

  // Note: stops propagation so a click inside a clickable table row opens the mail client instead of the row
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    openMailWithGmailFallback(email)
  }

  return (
    <S.Anchor href={`mailto:${email}`} onClick={handleClick}>
      {email}
    </S.Anchor>
  )
}
